import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormSection } from 'redux-form';

import {
	CUSTOM_FIELD_GENERATORS_BY_PLACEMENT_TYPE,
	PAC_FIELDS_BY_AD_TYPE
} from 'social/constants/placements';
import { SOCIAL_AD_TYPES } from 'utils/constants';
import { getFormStateByAdType } from 'selectors/Social2';

export default function PlacementForm(props) {
	const { placementType, defaultFieldGenerator, adType } = props;

	const isNew = useSelector((state) => {
		const { values } = getFormStateByAdType(state, adType);
		return values.placements?.[placementType]?._isNew;
	});

	const customGenerator = CUSTOM_FIELD_GENERATORS_BY_PLACEMENT_TYPE[placementType];
	const fieldGenerator = defaultFieldGenerator({ isNew, ...props }, customGenerator);

	const fieldNames = PAC_FIELDS_BY_AD_TYPE[adType][placementType] || [];

	const fields = useMemo(() => {
		return fieldNames.map((name) => {
			return fieldGenerator(name);
		});
	}, [adType, placementType]);

	return (
		<FormSection name={`placements.${placementType}`}>
			<div className="fields">
				{fields}
			</div>
		</FormSection>
	);
}

PlacementForm.propTypes = {
	placementType: PropTypes.string.isRequired,
	defaultFieldGenerator: PropTypes.func.isRequired,
	adType: PropTypes.oneOf([
		SOCIAL_AD_TYPES.FACEBOOK_IMAGE,
		SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO,
		SOCIAL_AD_TYPES.FACEBOOK_VIDEO,
		SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO,
	]).isRequired,
	showPristineErrors: PropTypes.bool,
};
